module.exports = {
      id: "whatsapp-circle-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b35941cc40d7fc0f39708cadaf87d26a.svg#whatsapp-circle-color",
      toString: function () {
        return this.url;
      }
    }